import type {DepartmentType} from '~/utils/types/account/departments/types'

export const initDepartment = (): DepartmentType => ({
    name: {},
    active: true,
    legalClient: false,
    fullLegalName: {},
    legalAddress: {},
    address: {},
    codeITN: null,
    codeKPP: null,
    currentAccount: null,
    bankName: {},
    bankIdentificationCode: null,
    correspondentAccount: null,
    codeOKPO: null,
    codeOKONKH: null,
    ceoName: {},
})
